<template>
  <div>
    <div class="live-item-hot" :title="live.title" @click="enterRoom(live)">
      <div class="item-tags">
        <div class="item-tag" :style="{ background: live.tag_color }" v-show="live.tag_title">{{ live.tag_title }}</div>
        <div class="item-tag" :style="{ background: '#FF69B4' }" v-show="live.guess_tag">竞猜</div>
      </div>
      <div class="hot-live-item" :style="height">
        <img v-lazy="thumbImg" class="item-cover" />

        <img class="play-icon" src="./img/live-play.png" alt="" />
      </div>
      <div class="hot-desc">
        <h3 class="desc-title">{{ live.title }}</h3>
        <div class="desc-content flex-middle-only">
          <img class="desc-logo" v-lazy="live.anchor_avatar" alt="" />
          <div class="user-name sl">
            {{ live.anchor_name }}
          </div>
          <div class="hot-content flex-end flex-middle-only">
            <img class="hot-icon" v-lazy="heatImg" />
            <span v-if="hotIndex == live.anchorid">{{ $bigNumber(hot) || 0 }}</span>
            <span v-else>{{ $bigNumber(live.hot) || 0 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { enterRoom } from "@/util/enterRoomTicket";
export default {
  name: "live-item-hot",
  components: {},
  props: {
    live: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "live",
    },
    height: {
      type: String,
      default: "",
    },
  },
  inject: ["reload"],

  computed: {
    ...mapState(["userInfo", "appConfig", "hot"]),
    heatImg() {
      return require("@/assets/home/fire.png");
    },
    link() {
      return `/liveMatchesTwo/${this.type === "live" ? this.live.anchorid : this.live.id}`;
    },
    thumbImg() {
      return this.live.thumb_y || this.live.thumb || require("./default_live_bg.png");
    },
  },

  data() {
    return {
      images: require("./queshengye.jpg"),
      hotIndex: "",
    };
  },
  mounted() {
    this.hotIndex = this.$route.params.id;
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    enterRoom,
    // JionRoom() {
    //   console.log("this.live.ticket", this.live);
    //   if (this.live.ticket > 0 && this.live.ticket_paid === 2) {
    //     if (!this.userInfo.id) {
    //       this.toggleLogin();
    //       return;
    //     }
    //     this.$refs.ticket.open();
    //   } else {
    //     this.$router.push(`/liveMatchesTwo/${this.live.anchorid}`);
    //     this.reload();
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
.live-item-hot {
  position: relative;
  overflow: hidden;
  padding: 0.06rem;
  transition: all 0.2s linear;
  transform: scale(1);
  border-radius: 0.08rem;
  cursor: pointer;

  &:hover {
    .play-icon {
      display: block !important;
    }
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 0.48rem;
    height: 0.48rem;
    display: none;
  }

  .item-tags {
    position: absolute;
    top: 0.16rem;
    right: 0.16rem;
    font-weight: 600;
    font-size: 0.14rem;
    color: #fff;
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .item-tag {
      padding: 0.02rem 0.08rem;
      border-radius: 0.04rem;
      margin-bottom: 0.06rem;
    }
  }

  &:hover {
    border-color: #02a8a2;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: scale(1.1);
  }

  .hot-live-item {
    overflow: hidden;
    border-radius: 0.06rem;
    //height: 1.39rem;
    position: relative;
    padding-bottom: 56%;
    .item-cover {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
  }

  .hot-desc {
    font-size: 0.15rem;
    color: #333;

    .desc-title {
      height: 0.22rem;
      line-height: 0.22rem;
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 0.1rem;
      font-weight: 400;
    }

    .desc-content {
      padding: 2px 0px;
      display: flex;
      flex-direction: row;
      align-items: center;

      img.desc-logo {
        background: rgba(0, 0, 0, 0.1);
        width: 0.24rem;
        height: 0.24rem;
        border-radius: 50%;
        margin-right: 0.05rem;
      }

      .user-name {
        font-size: 0.12rem;
        color: #999999;

        &.sl {
          width: 70px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .hot-content {
        flex: 1;
        text-align: right;
        color: #999;
        font-size: 0.12rem;
      }

      .hot-icon {
        margin-right: 0.03rem;
        height: 12px;
        width: 12px;
        padding: 0px 2px;
      }
    }
  }
}
</style>
